import { useCallback } from 'react';
import { toggleSnapping } from '../state/actions/toggle-snapping';
import { saveSnappingEnabled } from '../state/snapping-persistance';
import {
  useTimelineSnappingEnabled,
  useWriteContext,
} from '../utils/use-context';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { FluorescentFill } from '@crabs-ai/web-icons';

export function SnappingToggle() {
  const t = useTranslations();
  const writeContext = useWriteContext();
  const isSnappingEnabled = useTimelineSnappingEnabled();

  const handleToggle = useCallback(() => {
    writeContext.setState({
      update: (state) => {
        const newState = toggleSnapping(state);
        saveSnappingEnabled(newState.isSnappingEnabled);
        return newState;
      },
      commitToUndoStack: false,
    });
  }, [writeContext]);

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state={isSnappingEnabled ? 'selected' : 'default'}
      onClick={handleToggle}
      aria-label={isSnappingEnabled ? 'Disable Snapping' : 'Enable Snapping'}
      aria-pressed={isSnappingEnabled}
      aria-keyshortcuts="Shift+KeyM"
      isShowTooltip
      tooltipNode={
        isSnappingEnabled
          ? t('Editor.timeline-controls.snap-off')
          : t('Editor.timeline-controls.snap-on')
      }
    >
      <FluorescentFill className="size-5" />
    </ToolButton>
  );
}
